export function getNowTime (type) {
  let date = new Date()
  let year = date.getFullYear()
  let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let day = date.getDate()
  let hour = date.getHours() + ':'
  let minute = date.getMinutes() + ':'
  let second = date.getSeconds()
  let nowTime = year + '-' + month + '-' + day
  if (type !== 'date') {
    nowTime += ' ' + hour + minute + second
  }
  return nowTime
}

export function getDaysBetween (sDate1) {
  let time1 = Date.parse(new Date(sDate1))
  let time2 = Date.parse(new Date(getNowTime()))
  let nDays = parseInt((time1 - time2) / 1000 / 3600 / 24)
  if (nDays) {
    if (time1 > time2) {
      return nDays + '天前'
    } else {
      return -nDays + '天前'
    }
  } else if (parseInt((time1 - time2) / 1000 / 3600)) {
    if (time1 > time2) {
      return parseInt((time1 - time2) / 1000 / 3600) + '小时前'
    } else {
      return -parseInt((time1 - time2) / 1000 / 3600) + '小时前'
    }
  } else if (parseInt((time1 - time2) / 1000 / 60)) {
    if (time1 > time2) {
      return parseInt((time1 - time2) / 1000 / 60) + '分钟前'
    } else {
      return -parseInt((time1 - time2) / 1000 / 60) + '分钟前'
    }
  } else {
    return '刚刚'
  }
}
